import type { ActivityModule } from '../../core/activity';
import { mountLearnQuantities } from './ui';
import levelsData from './levels.json';
import './style.css';

export const learnQuantities: ActivityModule = {
  id: 'learn_quantities',
  title: 'Quantidades',
  description: 'Adicione laranjas até atingir o número pedido. Treina a noção de contagem e correspondência número↔quantidade.',
  ageMin: 4,
  ageMax: 7,
  difficulty: 1,
  iconPath: 'assets/gcompris-AGPL/learn_quantities/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountLearnQuantities,
};
